import { useMemo } from 'react'

import { formatBytes } from 'ui/components/FileUpload/utils'

import { useFileUploadItemContext } from './useFileUploadItemContext'

export function useFileUploadItemMetadataState() {
    const { nameId, sizeId, fileState } = useFileUploadItemContext()

    const fileName = fileState?.file.name
    const fileSize = useMemo(() => {
        const size = fileState?.file.size ?? 0

        return formatBytes(size)
    }, [fileState?.file.size])

    const errorMessage = fileState?.error

    const isError = fileState?.status === 'error'

    const isSuccess = fileState?.status === 'success'

    const isUploading = fileState?.status === 'uploading'

    return {
        fileName,
        fileSize,
        nameId,
        sizeId,
        errorMessage,
        isError,
        isSuccess,
        isUploading,
    }
}
